export enum SubStatusCodes {
    SentToWarehouse = '101',
    ReceivedInWarehouse = '201 - RECV',
    InPreparationAsigned = '202 - ALLO',
    InPreparationPick = '203 - PICK',
    Packaging = '204 - PACK',
    ReadyToShip = '206 - LOAD',
    Carrier = '01',
    InDistribution = '10',
    InStore = '100',
    InDroppoint = '08',
    Rejected = '09',
    Delivered = '02',
}

export enum SubStatusWording {
    SentToWarehouse = 'dev.myOrders.subStatus.sendedToWarehouse',
    ReceivedInWarehouse = 'dev.myOrders.subStatus.receivedInWarehouse',
    InPreparation = 'dev.myOrders.subStatus.inPreparation',
    Packaging = 'dev.myOrders.subStatus.packaging',
    ReadyToShip = 'dev.myOrders.subStatus.readyToShip',
    InCarrier = 'dev.myOrders.subStatus.inCarrier',
    InDistribution = 'dev.myOrders.subStatus.inDistribution',
    InStore = 'dev.myOrders.subStatus.inStore',
    InDroppoint = 'dev.myOrders.subStatus.inDroppoint',
    Delivered = 'dev.myOrders.status.delivered',
}
